import React, { useRef, Suspense, useCallback, useEffect } from 'react'
import { Canvas, extend, useFrame, useThree } from 'react-three-fiber';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Tween, autoPlay } from 'es6-tween';

import Drum from './Drum'
import DiscoBall from './DiscoBall'
import Particles from './Particles'
import FollowLight from './FollowLight'
import Effects from './Effects'

import '../libs/BAS'
import { initParticleSystem } from '../libs/Confetti'

extend({ OrbitControls })
autoPlay(true)

function Controls() {
  const controls = useRef()
  const { camera, gl } = useThree()
  useFrame(() => controls.current.update())
  return (
    <orbitControls ref={controls} args={[camera, gl.domElement]} enableDamping dampingFactor={0.1} rotateSpeed={0.5} />
  )
}

function Confetti({ trigger, position }) {
  const particle = useRef(0)
  const { scene } = useThree()

  const tween = useRef(null)
  const anim = useRef({ morph: 0 })
  useEffect(() => {
    if (trigger && (anim.current.morph === 0 || anim.current.morph > 0.75)) {
      if (tween.current) tween.current.stop()
      anim.current.morph = 0
      tween.current = new Tween(anim.current)
        .to({ morph: 1 }, 5000)
        .on('update', ({ morph }) => {
          if (particle.current) particle.current.material.uniforms['uTime'].value = morph * 8;
        })
        .start();
    }
  }, [trigger])

  useEffect(() => {
    particle.current = new initParticleSystem();
    particle.current.scale.set(0.025, 0.025, 0.025);
    particle.current.position.set(...position)
    scene.add(particle.current)
  }, [])

  return (
    <></>
  )
}

function Loaded() {
  useEffect(() => {
    console.log('moi')
  }, [])

  return (
    <></>
  )
}

const Graphics = ({ leftTrigger, rightTrigger, mobile, isPlaying, ...props }, ref) => {
  const mouse = useRef([0, 0])
  const onMouseMove = useCallback(({ clientX: x, clientY: y }) => {
    if (mobile) (mouse.current = [y - window.innerHeight / 2, (x - window.innerWidth / 2) * -1])
    else (mouse.current = [x - window.innerWidth / 2, y - window.innerHeight / 2])
  }, [])

  return (
    <Canvas
      gl={{ alpha: false, antialias: false }}
      onCreated={({ gl }) => {
        gl.setClearColor(0x2f2f2f)
      }}
      onPointerMove={onMouseMove}
      camera={{ position: [0, 7.5, mobile ? 25 : 15], rotation: [0, 0, mobile ? Math.PI * 0.5 : 0], far: 15000, near: 0.01 }}>

      <Suspense fallback={null}>
        <group rotation={[-0.175, 0, 0]}>
          <group position={[-6, 0, 0]} scale={[0.67, 0.67, 0.67]}>
            <Drum trigger={leftTrigger} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          </group>
          <group position={[-10.75, 0, 0]} scale={[0.33, 0.33, 0.33]}>
            <Drum trigger={leftTrigger} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          </group>
          <Drum trigger={leftTrigger} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          <Drum trigger={rightTrigger} flip={true} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          <group position={[6, 0, 0]} scale={[0.67, 0.67, 0.67]}>
            <Drum trigger={rightTrigger} flip={true} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          </group>
          <group position={[10.75, 0, 0]} scale={[0.33, 0.33, 0.33]}>
            <Drum trigger={rightTrigger} flip={true} isPlaying={isPlaying} setLoaded={props.setLoaded} />
          </group>
        </group>

        <group position={[-7.5, 17.5, 0]}>
          <DiscoBall leftTrigger={leftTrigger} rightTrigger={rightTrigger} flip={-1} isPlaying={isPlaying} />
        </group>
        <group position={[7.5, 17.5, 0]}>
          <DiscoBall leftTrigger={leftTrigger} rightTrigger={rightTrigger} flip={1} isPlaying={isPlaying} />
        </group>
      </Suspense>

      <Confetti position={[-15, 0, -5]} trigger={leftTrigger === 0 && isPlaying}></Confetti>
      <Confetti position={[-5, 0, -5]} trigger={leftTrigger === 1 && isPlaying}></Confetti>
      <Confetti position={[5, 0, -5]} trigger={rightTrigger === 0 && isPlaying}></Confetti>
      <Confetti position={[15, 0, -5]} trigger={rightTrigger === 1 && isPlaying}></Confetti>

      <Particles count={2500} mouse={mouse} />
      <FollowLight mouse={mouse} />
      <Effects />
      {/* <Controls /> */}
    </Canvas>
  );
};

export default React.forwardRef(Graphics);
